import { createContext } from "react";

const InterviewsContext = createContext({});

export default InterviewsContext;